import { combineReducers } from 'redux';
import user from './userReducer';
import staff from './staffReducer';
import attendance from './attendanceReducer';
import payment from './paymentReducer';
import report from './reportReducer';
import settings from './settingsReducer';
import notifications from './notificationReducer';
import mapview from './mapViewReducer';
import lead from './leadReducer';
import controlCenter from './controlCenterReducer';
import cm from './cmReducer';
const rootReducer = combineReducers({
    user,
    staff,
    attendance,
    payment,
    report,
    settings,
    notifications,
    mapview,
    lead,
    controlCenter,
    cm,
});

export default rootReducer;
